import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { getQueryParam, mergeQueryParam, stripQueryParam } from './utils';

export function useUrlQueryParam(
  paramKey: string,
  defaultValue: string = ''
): {
  queryParam: string;
  setQueryParam: (value: string) => void;
  removeQueryParam: () => void;
} {
  const { search } = useLocation();
  const history = useHistory();
  const rawQueryParam = getQueryParam(search, paramKey);

  const setQueryParam = useCallback(
    (value: string) => {
      const newSearch = mergeQueryParam(search, paramKey, value);
      history.replace({ search: newSearch });
    },
    [search, paramKey, history]
  );

  const removeQueryParam = useCallback(() => {
    const newSearch = stripQueryParam(search, paramKey);
    history.replace({ search: newSearch });
  }, [search, paramKey, history]);

  const queryParam = rawQueryParam || defaultValue;

  return { queryParam, setQueryParam, removeQueryParam };
}
